/**
 * 同一屏上同名的宠物怎么分开叫（SAME-NAME-LABEL-117；用户 10-16 同意两边都不改名，I 10-16 定口径）。
 * - 只在这一屏渲染出来的名单里，两个及以上不同的宠物（按 id 算）名字一模一样（去掉首尾空白后逐字相同），而且其中有平台居民时才加。
 * - 只加在**居民**那一边，写「{城市}居民」（例：西安居民）；城市读不到写「星球居民」。主人的宠物一律不加：
 *   写出主人宠物的城市，等于告诉看的人这户住在哪座城（主人的家在真实小区，用户 10-08）。
 * - 认不出是不是居民（resident 为 null）的那几位不加，也不当成居民（I 10-16：分不出就不猜，等后端补字段）。
 * - 不改名、不动数据，只决定这一屏名字旁边多一小行什么字。读音相同、字形相近的不管（字不同）。
 * 地图上的 withCityOnSameName（6c2b）118 再统一调这里，现在口径一致：两位居民同名各带城市。
 */
export interface NameEntry {
  /** 这一位是谁（宠物 id）：同一位出现两次不算重名 */
  id: string;
  name: string;
  /** 是不是平台居民；认不出就是 null */
  resident: boolean | null;
  /** 居民所在的城市（只看居民的） */
  city?: string | null;
}

/** 居民那一边的小字 */
export function residentTag(city: string | null | undefined): string {
  const place = city?.trim();
  return place ? `${place}居民` : "星球居民";
}

/** 这一屏里每一位要加的小字：id → 小字；不用加的不在里面 */
export function sameNameTags(entries: readonly NameEntry[]): Map<string, string> {
  const byName = new Map<string, Map<string, NameEntry>>();
  for (const entry of entries) {
    const name = entry.name.trim();
    if (!name) continue;
    const people = byName.get(name) ?? new Map<string, NameEntry>();
    if (!people.has(entry.id)) people.set(entry.id, entry);
    byName.set(name, people);
  }
  const tags = new Map<string, string>();
  for (const people of byName.values()) {
    if (people.size < 2) continue;
    for (const entry of people.values()) if (entry.resident === true) tags.set(entry.id, residentTag(entry.city));
  }
  return tags;
}
